// eslint-disable-next-line no-restricted-imports
import { gatsbyBrowserRootWrapper } from './gatsbyBrowserRootWrapper';

export const wrapRootElement = gatsbyBrowserRootWrapper;
